import {
  CustomDeviceIcon,
  DesktopDeviceIcon,
  MobileDeviceIcon,
  ResponsiveDeviceIcon,
  TabletDeviceIcon,
} from '@carboncopyco/icons';
import type { Config } from './types';

export const CONFIG: Config = {
  responsive: {
    label: 'Responsive',
    imageComponent: <ResponsiveDeviceIcon size={68} />,
    dimension: null,
    hint: 'Scale frame elements according to viewer’s screen. Note: your app must be responsive in order to support it.',
  },
  desktop: {
    label: 'Desktop',
    imageComponent: <DesktopDeviceIcon size={68} />,
    dimension: {
      width: 1920,
      height: 1080,
    },
    hint: null,
  },
  tablet: {
    label: 'Tablet',
    imageComponent: <TabletDeviceIcon size={68} />,
    dimension: {
      width: 768,
      height: 1024,
    },
    hint: null,
  },
  mobile: {
    label: 'Mobile',
    imageComponent: <MobileDeviceIcon size={68} />,
    dimension: {
      width: 360,
      height: 800,
    },
    hint: null,
  },
  custom: {
    label: 'Custom',
    imageComponent: <CustomDeviceIcon size={68} />,
    dimension: null,
    hint: null,
  },
};
